module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa4.c29342c35e15ace82921c905a1c1a878.png";